import React from 'react'
import Loader from '../Loader'

export default ({ text, style = {}, extra }) => (
  <div
    style={{
      zIndex: 10004,
      marginTop: 80,
      ...style,
    }}
    className="uk-fixed uk-background-default uk-width-expand uk-height-viewport uk-position-top-left uk-flex-column"
  >
    <Loader visible text={text} />
    {extra}
  </div>
)
